import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from 'react-router-dom';

import TextInput from "components/Input/TextInput";
import Button from "components/Button";
import FeedbackModal from "components/FeedbackModal";

import routes from "configs/routes";

import clg from "functions/log";
import auth from "functions/auth";
import modifyState from "functions/modifyState";

import 'assets/css/Login.min.css';

const Login = () => {

    const history = useHistory();
    const location = useLocation();

    const [feedback,setFeedback] = useState({
        open : false,
        success : false,
        title : null,
        text : null,
    })

    const [showValidationStatus, setShowValidationStatus] = useState(0);

    useEffect(() => {
        if( auth.isAuthenticated() ) {
            if( location.pathname === history.location.pathname ) {
                history.replace(routes.dashboard);
            }
        }
    },[])

    const [loginData, setLoginData] = useState({
        email : {
            value : null,
            validation : false,
        },
        password : {
            value : null,
            validation : false,
        },
    });

    const login = () => {
        //Ha a mezők kitöltése megfelelő
        if( loginData.email.validation && loginData.password.validation ) {
            setShowValidationStatus(0);

            auth.login( {email : loginData.email.value, password : loginData.password.value} )
            .then(function(res){
                clg("LOGIN RES: ", res);
                if( res && res.success ) {
                    history.replace(routes.dashboard);
                }
            })
            .catch(function(err){
                if( err && err.hasOwnProperty( "http_status_code" ) ) {
                    switch (err.http_status_code) {
                        case 400:
                            modifyState( feedback, setFeedback, {"open" : true, "success" : false, "text" : "A felhasználónév vagy jelszó hibás."} );
                            break;
                        default :
                            modifyState( feedback, setFeedback, {"open" : true, "success" : false, "text" : "Hiba történt a bejelentkezés során. Próbálja újra!"} );
                            break;
                    }
                } else {
                    modifyState( feedback, setFeedback, {"open" : true, "success" : false, "text" : "Hiba történt a bejelentkezés során. Próbálja újra!"} );
                }
            })

        } else {
            //Ha a mezők kitöltése nem megfelelő
            modifyState( feedback, setFeedback, {"open" : true, "success" : false, "text" : "A *-gal jelölt mezők kitöltése kötelező!"} );
            setShowValidationStatus(1);
        }
    }

    return(
        <div className="container">
            <div className="row">
                <div className="col-12 login-card">
                    
                    <form className="row">

                        <div className="col-12 user-icon"><i className="fas fa-user-circle"></i></div>

                        <div className="col-12">
                            <TextInput
                                type="text"
                                label="Felhasználónév"
                                onChange={ (e) => {
                                    setLoginData({
                                        ...loginData,
                                        email : {
                                            value : e.value,
                                            validation : e.validation.status,
                                        }
                                    })
                                }}
                                conditions={{
                                    minLength : 1,
                                }}
                                show_validation_status={showValidationStatus}
                                required
                            />
                        </div>
                        <div className="col-12">
                            <TextInput
                                type="password"
                                label="Jelszó"
                                onChange={ (e) => {
                                    setLoginData({
                                        ...loginData,
                                        password : {
                                            value : e.value,
                                            validation : e.validation.status,
                                        }
                                    })
                                }}
                                conditions={{
                                    minLength : 1,
                                }}
                                show_validation_status={showValidationStatus}
                                required
                            />
                        </div>
                        <div className="col-12 d-flex justify-content-center">
                            <Button className="btn-secondary" text="Bejelentkezés" onClick={ (e) => {
                                e.preventDefault();
                                login();
                            }}/>
                        </div>
                    </form>

                </div>
            </div>

            <FeedbackModal open={feedback.open} success={feedback.success} title={feedback.title} text={feedback.text} defaultState={ feedback } setDefaultState={ setFeedback }/>

        </div>
    )
}

export default Login;